/**
 * @file commonDataSourceManager.js
 * @desc Provides the commonDataSourceManager module, which is responsible for loading up
 * common data sources like the report list and org list.
 * @author Geoffrey Pursell
 */


define('commonDataSourceManager',["jquery", "underscore", "underscore.string", "backbone", "rsvp",
        "commonDataSources", "cardboard/models", "models", "cardboard/util", "bloodhound"],
       function ($, _, _s, Backbone, RSVP,
                  CommonDataSources, CardboardModels, Models, Util, Bloodhound) {

    console.log("MODULE: commonDataSourceManager");


    /**
         * @exports commonDataSourceManager
         * @desc contains specific data model objects that go get specific
         * data.
         */


    var Promise = RSVP.Promise;


    //
    // DEBUGGING
    //

    window.showGenericSubjects = function () {
        inspectGlobalSource("genericSubjects");
    };
    window.showGenericCategories = function () {
        inspectGlobalSource("genericCategories");
    };
    window.showFilteredGenericSubjects = function () {
        inspectDerivativeSource("filteredGenericSubjects");
    };
    window.showFilteredGenericCategories = function () {
        inspectDerivativeSource("filteredGenericCategories");
    };
    window.showUnfilteredOrgList = function () {
        Util.inspectJSON(CommonDataSources.entities.unfilteredOrgList, "Unfileted Org List JSON");
    };

    function loadSucceeded(id) {
        var el = document.getElementById(id);
        el.innerHTML = el.innerHTML + "done! ";
    }

    function loadFailed(id) {
        var el = document.getElementById(id);
        el.innerHTML = el.innerHTML + "failed! ";
    }


    //
    // PRIVATE UTILITY STUFF
    //



    // a few functions to do generation of the typeahead datasets
    function inspectGlobalSource(sourceName) {
        Util.inspectJSON(CommonDataSources[sourceName].toJSON(), sourceName + " JSON");
    }

    function inspectDerivativeSource(sourceName) {
        Util.inspectJSON(CommonDataSources.Derivative[sourceName].toJSON(), sourceName + " JSON");
    }


    /**
         * @class CommonDataSourceManager
         * @classdesc A class to manage the loading and filtering of common data sources
         */

    var CommonDataSourceManager = function () {
        this.attachGlobalEvents();
        this.initialize.apply(this, arguments);
    };

    CommonDataSourceManager.prototype = /** @lends module:commonDataSourceManager.prototype */ {
        /** global declarative events to listen for; designed to mimic the
             * behavior of the events hash on Backbone views */
        globalEvents: {},

        /** attach declarative global events */
        attachGlobalEvents: Util.attachGlobalEvents,

        orgListsReady: null,
        dataSourcesReady: {},
        dataSourcesReadyArray: [],


        //
        // PUBLIC METHODS
        //
        // these are to be called at the appropriate times by main, and by the
        // MainWorkspaceController

        initialize: function () {

        },




        /** called ASAP by main to get these data sources loading up as early as
             * possible. events will be dispatched once they're loaded, parsed, and
             * ready to go. */
        fetchCommonDataSources: function () {
            var self = this;

            $("#pageLoadingStatus").show();

            //   this.orgListsReady = CommonDataSources.entities.fetch();

            this.dataSourcesReady = {
                /* jshint indent:false */

                // LEARNING EXPERIENCE: unless I return the passed error object
                // in each of these error handlers, any promise callback
                // downstream thinks everything is okay!
               /* loadDynamicText: CommonDataSources.dynamicText.fetch()
                .then(function () {
                    loadSucceeded("pageLoadingStatus_dynamicText");
                   // self.filterEntitiesForReport();
                }, function (e) {
                    loadFailed("pageLoadingStatus_dynamicText");
                    return e;
                }),

                // fetch the global sources
                    loadOrgList: this.orgListsReady
                        .then(function () {
                            loadSucceeded("pageLoadingStatus_orgList");
                            self.filterEntitiesForReport();
                        }, function (e) {
                            loadFailed("pageLoadingStatus_orgList");
                            return e;
                        }),*/
                loadReportInfo: CommonDataSources.reportInfo.fetch()
                .then(function () {
                    loadSucceeded("pageLoadingStatus_reportInfo");
                },
                      function (e) {
                    loadFailed("pageLoadingStatus_reportInfo");
                    return e;
                })
                // loadFilters: CommonDataSources.filters.fetch()
                // 	.then(function () { loadSucceeded("pageLoadingStatus_loadFilters"); },
                // 		  function (e) { loadFailed("pageLoadingStatus_loadFilters"); return e; })
            };

            // make "all sources ready" promise
            this.dataSourcesReadyArray = _(this.dataSourcesReady).toArray().value();
            this.allSourcesReady = Promise.all(this.dataSourcesReadyArray);
            return (this.allSourcesReady);
        },


        filterCommonDataSourcesForReport: function (/*report*/) {

        },

        //
        // COMMON DATA SOURCE FILTERING
        // 

        /** called by the MainWorkspaceController on every report change */
        /*       filterCommonDataSourcesForReport: function (report) {
                if (report) {
                    return this.filterEntitiesForReport(report);
                }
                return null;
            },
            filterEntitiesForReport: function () {
                // in SLEDS, we currently have no need to re-filter these lists when
                // the report changes.

                var CD = CommonDataSources.Derivative,
                    orgList = CommonDataSources.entities;

                CD.orgFinderTypeaheadSchools = orgList.unfilteredSchools;
                console.log(orgList);
                CD.orgFinderTypeaheadDistricts = orgList.unfilteredGroups.district;

                if (!CD.bloodhoundsCreated) {
                    this.makeBloodhounds();
                    return this.initBloodhounds();
                } else {
                    return Promise.resolve();
                }
            },*/

    };


    return CommonDataSourceManager;
});
